// src/app/store.ts
import { configureStore } from "@reduxjs/toolkit";
import uploadReducer from "./features/upload/uploadSlice";
import authReducer from "./features/authSlice";
import commonReducer from "./features/common/commonSlice";
import { logoutMiddleware } from "./middleware/logoutMiddleware";

export const store = configureStore({
  reducer: {
    upload: uploadReducer,
    auth: authReducer,
    common: commonReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(logoutMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
